export const COOKIE_BANNER_KEY = 'DSG';

export const COOKIE_BANNER_DURATION = 365;
